import {NoteChangePrice} from "../types/note-change-price.types";

export const defaultNoteChangePrice: NoteChangePrice = {
  id: 0,
  productId: 0,
  article: '',
  advertisementsExpensesShareBefore: 0,
  advertisementsExpensesShareAfter: 0,
  revenueBefore: 0,
  revenueAfter: 0,
  profitBefore: 0,
  profitAfter: 0,
  noteId: 0,
  customerPriceBefore: 0,
  customerPriceAfter: 0,
  sppBefore: 0,
  sppAfter: 0,
  marketplacePriceBefore: 0,
  marketplacePriceAfter: 0,
  unitProfitBefore: 0,
  unitProfitAfter: 0,
  cpoBefore: 0,
  cpoAfter: 0,
  salesQuantityBefore: 0,
  salesQuantityAfter: 0,
  advertisementBudget: 0,
  comment: ''
}
